import { AnchorDate } from "../anchor-date/anchor-date.enum";
import { DatePeriodDefinition } from "./date-period.model";

export type DatePeriodKeys = keyof typeof DATE_PERIOD_REGISTRY; 

export const DATE_PERIOD_REGISTRY = {
    /* Custom */
    custom: {
        key: 'custom',
        type: 'Custom',
        label: 'Custom',
        anchorDate: AnchorDate.Today
    },

    /* Current Month */
    currentMonth: {
        key: 'currentMonth',
        type: 'CurrentMonth',
        label: 'Current Month',
        anchorDate: AnchorDate.Today
    },

    /* YearToDate */
    yearToDate: {
        key: 'yearToDate',
        type: 'YearToDate',
        label: 'Year To Date',
        yearBasis: 'calendar',
        anchorDate: AnchorDate.Today
    },
    fiscalYearToDate: {
        key: 'fiscalYearToDate',
        type: 'YearToDate',
        label: 'Fiscal Year To Date',
        yearBasis: 'fiscal',
        anchorDate: AnchorDate.Today,
        requiresFiscalStartMonth: true
    },
    
    /* SingleDay */
    currentDate: {
        key: 'currentDate',
        type: 'SingleDate',
        label: 'Today',
        anchorDate: AnchorDate.Today
    },
    lastDeliveryByDeliveryCenter: {
        key: 'lastDeliveryByDeliveryCenter',
        type: 'SingleDate',
        label: 'Last Delivery',
        anchorDate: AnchorDate.LastDeliveryByDeliveryCenter
    },
    lastDeliveryByDivision: {
        key: 'lastDeliveryByDivision',
        type: 'SingleDate',
        label: 'Last Delivery',
        anchorDate: AnchorDate.LastDeliveryByDivision
    },
    lastInvoice: {
        key: 'lastInvoice',
        type: 'SingleDate',
        label: 'Last Invoice',
        anchorDate: AnchorDate.LastInvoice
    },
    lastServiceCall: {
        key: 'lastServiceCall',
        type: 'SingleDate',
        label: 'Last Service Call',
        anchorDate: AnchorDate.LastServiceCall
    },

    /* LastXPeriods */
    last15Days: {
        key: 'last15Days',
        type: 'LastXPeriods',
        label: 'Last 15 Days',
        anchorDate: AnchorDate.Today,
        periodUnit: 'day',
        periodCount: 15
    },
    last15DaysDeliveryByDivision: {
        key: 'last15DaysDeliveryByDivision',
        type: 'LastXPeriods',
        label: 'Last 15 Days (Delivery)',
        anchorDate: AnchorDate.LastDeliveryByDivision,
        periodUnit: 'day',
        periodCount: 15
    },
    last30Days: {
        key: 'last30Days',
        type: 'LastXPeriods',
        label: 'Last 30 Days',
        anchorDate: AnchorDate.Today,
        periodUnit: 'day',
        periodCount: 30
    },
    last30DaysDeliveryByDivision: {
        key: 'last30DaysDeliveryByDivision',
        type: 'LastXPeriods',
        label: 'Last 30 Days (Delivery)',
        anchorDate: AnchorDate.LastDeliveryByDivision,
        periodUnit: 'day',
        periodCount: 30
    },
    last3Months: {
        key: 'last3Months',
        type: 'LastXPeriods',
        label: 'Last 3 Months',
        anchorDate: AnchorDate.Today,
        periodUnit: 'month',
        periodCount: 3
    }


} satisfies Record<string, DatePeriodDefinition>